import type { Theme } from '@mui/material';

export const styles = {
  button: {
    height: '100%',
    px: 1.25,
    '.MuiButton-startIcon': {
      mr: 1,
    },
  },

  dialogContent: (theme: Theme) => ({
    color: theme.colors.primary[500],
  }),
};
